import React, { useEffect, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";
import "./CategoryList.scss"
import { CityAndStateService, LocationService } from "shared/services";
import { calender, crossIcon, updownArrow } from "shared/assets/icons";
import { useRef } from "react";
import moment from "moment";
import { addDataLayer } from "shared/utils/utils";
export default function CategoryFilter({ filterData, onApply, hidefilter, viewModal, setviewModal, defaultkey, resetFilter,defultFilter }) {
    const category = useSelector(state => state?.category);
    const [filterinput, setfilterinput] = useState({
        zipcode: "",
        miles: "",
        min:"",
        max:"",
        startdate:"",
        enddate:"",
        categoryGroup:"",
        category:"",
        locationid:"",
        itemtype: "",
        state:"",
        keyword:"",
        area:"",
    })
    const [subCategory, setsubCategory] = useState([])
    const [displaycat, setdisplaycat] = useState([])
    const [displayloc, setdisplayloc] = useState([])
    const [locationlist, setlocationlist] = useState([])
    const [stateList, setstateList] = useState([])
    const [width, setwidth] = useState(window?.innerWidth)
    const [errors, seterrors] = useState({})
    const [defaultFilterVal, setdefaultFilterVal] = useState({})
    
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        let data = { ...filterinput }
        Object.keys(data).map((item) => {
            if (item == "categoryGroup" && filterData?.[item] != "") {
                let index = category.findIndex(i => i.label == filterData?.[item])
                if (index >= 0) {
                    setsubCategory(category[index].subCategory);

                    let dataLayerData = {
                        'event': 'category',
                        'title': filterData?.[item]
                    }
                    addDataLayer(dataLayerData);
                }
            }
            if (item in filterData) {
                data[item] = filterData?.[item]
            } else {
                data[item] = item == "itemtype" ? [] : ""
            }
        })
        let defdata = { ...filterinput }
        Object.keys(defdata).map((item) => {
            if (item == "categoryGroup" && defultFilter?.[item] != "") {
                let index = category.findIndex(i => i.label == defultFilter?.[item])
                if (index >= 0) {
                    setsubCategory(category[index].subCategory);

                    let dataLayerData = {
                        'event': 'category',
                        'title': defultFilter?.[item]
                    }
                    addDataLayer(dataLayerData);
                }
            }
            if (item in defultFilter) {
                defdata[item] = defultFilter?.[item]
            } else {
                defdata[item] = item == "itemtype" ? [] : ""
            }
        })
        seterrors({})
       
        setdefaultFilterVal({...defultFilter})
        setfilterinput({ ...data })
        setData()
        window.addEventListener('resize', () => {
            setwidth(window?.innerWidth)
        });
        return () => {

        }
    }, [filterData])
    const setData = async () => {
        if (locationlist.length > 0) {
            let index = category.findIndex(i => i.label == filterData?.categoryGroup)
            setdisplaycat(category.slice(0, index > 5 ? index + 1 : 5))
        } else {
            await getLocations()
            await getStateList()
        }
    }
    const getLocations = async () => {
        const payload = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "field": ["id", "title"]
        };
        await LocationService.getLocationList(payload).then((response) => {
            let list = response?.data?.data
            setlocationlist(list)
            setdisplayloc(list.slice(0, 5))
            let index = category.findIndex(i => i.label == filterData?.categoryGroup)
            setdisplaycat(category.slice(0, index > 5 ? index + 1 : 5))
        })
            .catch(error => {
            });
    }
    const getStateList = async () => {
        await CityAndStateService.getStateList().then((response) => {
            let list = response?.data?.data
            setstateList(list)
        })
    }
    const checkoption = async (event) => {
        await onInputValidation(event, "itemtype")
        applyfilter({ itemtype: filterinput.itemtype })

    }
    const onInputValidation = (event, key = "itemtype") => {
        if (event?.target?.name == "categoryGroup" && key != "date") {
            let index = category.findIndex(i => i.label == event.target.value)
            if (index >= 0) {
                setsubCategory(category[index].subCategory)
            }
        }
        let filterData = filterinput 
        if (key == "date") {
            // if ((moment(event)).isSameOrBefore(moment())) {
            //     filterData[event.name]["error"] = `${event.name == "startdate" ? "Start" : "End"} date time should be greater than the current time`;
            // }
            filterData[event.name] = event.value
        } else {
            if (event.target.name === 'zipcode') {
                if (isNaN(Number(event.target.value)))
                    event.target.value = '';
            } 
            if(event.target.name === 'min' || event.target.name === 'max') {
                if (isNaN(Number(event.target.value)))
                    event.target.value = filterData?.[event.target.name];
            }
            if(event.target.name === 'keyword'){
                let exp = /^[a-zA-Z0-9!@#$%^&* ]+$/g;
                if(!exp.test(event.target.value) && event.target.value  != "") {
                    event.target.value=filterData?.[event.target.name]
                }
            }
            if (event.target.type == "checkbox") {
                if (key === "itemtype") {
                    if (!filterData[key].includes(event.target.name)) {
                        filterData[key].push(event.target.name)
                        if (event.target.name == "directBuy") {
                            filterData[key] = filterData[key].filter(item => (!(item == "auction" || item == "buynow")))
                        } else if (event.target.name == "auction" || event.target.name == "buynow") {
                            filterData[key] = filterData[key].filter(item => (item != "directBuy"))
                        } else if (event.target.name == "isshippable") {
                            filterData[key] = filterData[key].filter(item => (item != "pickuponly"))
                        } else if (event.target.name == "pickuponly") {
                            filterData[key] = filterData[key].filter(item => (item != "isshippable"))
                        }
                    } else {
                        filterData[key].splice(filterData[key]?.indexOf(event.target.name), 1)
                    }
                } else {
                    filterData[key] = event.target.checked ? event.target.name : ""
                }
            }
            else {
                filterData[event.target.name] = event.target.value
            }
        }
        setfilterinput({...filterData})
    }
    const setcat = (value, key) => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        } else {
            window.scrollTo(0, 0);
        }

        setfilterinput((prevState) => {
            prevState[key] = value?.label

            if ( key === "categoryGroup" ) {
                prevState.category = "";
            }

            if ( typeof location.pathname === 'string' && location.pathname.startsWith('/category') ) {
                let url = '/category';
                if ( prevState.categoryGroup ) {
                    url += `/${prevState.categoryGroup}`;
                }

                if ( prevState.category ) {
                    url += `/${prevState.category}`;
                }
            
                history.replace(url);
            }

            return { ...prevState }
        })
        if (key === "categoryGroup") {
            applyfilter({ [key]: value?.label, category: "" })
        } else {
            applyfilter({ [key]: value?.label })
        }
    }
    const applyfilter = (filter, key = "") => {
        let filtervalues = { ...filterData }
        let error = {}
        if(key == "all" || key == "price") {
            if( filterinput?.min != "" &&  filterinput?.max != "") {
                if(!(parseFloat(filterinput?.min) <= parseFloat(filterinput?.max))){
                    error["price"] = "Max value should be greater than min value"
                }
            } 
        } 
        if(key == "all" || key == "date") {
            let start = moment(filterinput?.startdate)
            let end = moment(filterinput?.enddate)
            if (moment(start).isSameOrAfter(moment(end))) {
                error["date"] ="Start time should not be greater than or equal to end time";
            }

        }
        seterrors(error)
        if(!(Object.keys(error).length > 0)) {
        if (key == "all") {
            filtervalues = {...filterinput }
        } else if (key == "date") {
            filtervalues["startdate"] = filterinput?.startdate
            filtervalues["enddate"] = filterinput?.enddate

        } else if (key == "price") {
            filtervalues["min"] = filterinput?.min
            filtervalues["max"] = filterinput?.max
        } else if (key == "keyword") {
            filtervalues["keyword"] = filterinput?.keyword
        } else if (key == "location") {
            filtervalues["zipcode"] = filterinput?.zipcode
            filtervalues["miles"] = filterinput?.miles
        }
        filtervalues = { ...filtervalues, ...filter }
        onApply(filtervalues)
        }

    }
    const reset = () => {
        let data = { ...defaultFilterVal }
        // Object.keys(data).map((item) => {
        //     if (item == "categoryGroup" && filterData?.[item] != "") {
        //         let index = category.findIndex(i => i.label == filterData?.[item])
        //         if (index >= 0) {
        //             setsubCategory(category[index].subCategory)
        //         }
        //     }
        //     if (item in filterData) {
        //         data[item] = filterData?.[item]
        //     } else {
        //         data[item] = item == "itemtype" ? [] : ""
        //     }
        // })
        
        setfilterinput({ ...data })

    }

    const isAllFieldsEmpty = Object.keys(filterinput).every(key => (Array.isArray(filterinput[key]) ?defaultFilterVal[key] === filterinput[key]:filterinput[key] === defaultFilterVal[key]))
    // const isAllFieldsEmpty = Object.keys(filterinput).every(key =>
    //     Array.isArray(filterinput[key])
    //       ? (defaultFilterVal[key] === filterinput[key] || filterinput[key].length === 0)
    //       : (filterinput[key] === defaultFilterVal[key] || filterinput[key] === "")
    //   );
    // JSON.stringify(defaultFilterVal) == JSON.stringify(filterinput)
    //  Object.values(filterinput).every(field => {
    //     if (Array.isArray(field)) return field.length === 0;
    //     return field === '';
    // });

    if (width <= 800) {
        return (
            <div>
                {viewModal && <div className="category-modalui">
                    <div className="modalui-cont shadow">
                        <Button className="close-btn" onClick={()=>{setviewModal(false)}}>{crossIcon}</Button>
                        <div className="category-modalui-content">
                        {!hidefilter?.includes("locationid") && <div className="w-100"><Form.Group className="inputcont">
                            <Form.Label>Location</Form.Label>
                            <Form.Select as="select" name="locationid" value={filterinput?.locationid} onChange={(event) => { onInputValidation(event) }}>
                                <option value="All">All Locations</option>
                                {
                                    locationlist.map(loc =>
                                        <option value={loc.id} key={loc.title}>{loc.title}</option>
                                    )
                                }
                            </Form.Select>
                        </Form.Group>
                            <Form.Group className="inputcont">
                                <Form.Label>Zip code</Form.Label>
                                <Form.Control type="text" maxLength={5} placeholder="Enter Zip code" aria-label='Enter zipcode' name="zipcode" value={filterinput.zipcode} onChange={(event) => onInputValidation(event)} />
                            </Form.Group>
                            <Form.Group className="inputcont">
                                <Form.Label>State</Form.Label>
                                <Form.Select as="select" name="state" value={filterinput?.state} onChange={(event) => { onInputValidation(event) }}>
                                    <option value="All">All State</option>
                                    {
                                        stateList.map(loc =>
                                            <option value={loc.state} key={loc.state}>{loc.state}</option>
                                        )
                                    }
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="inputcont">
                                <Form.Label>Within the radius of</Form.Label>
                                <Form.Select role={"button"} as="select" placeholder="Select Distance" aria-label='Select Distance' name="miles" value={filterinput.miles} onChange={(event) => onInputValidation(event)}>
                                    <option selected hidden>Select Distance</option>
                                    <option value="5">5 Miles</option>
                                    <option value="10">10 Miles</option>
                                    <option value="25">25 Miles</option>
                                    <option value="50">50 Miles</option>
                                    <option value="100">100 Miles</option>
                                    <option value="250">250 Miles</option>
                                </Form.Select>
                            </Form.Group>
                        </div>}
                        <Form.Group className="inputcont">
                            <Form.Label>Category</Form.Label>
                            <Form.Select as="select" name="categoryGroup" value={filterinput?.categoryGroup} onChange={(event) => { onInputValidation(event) }}>
                                <option value="All">All Category</option>
                                {
                                    category.map(loc =>
                                        <option value={loc.label} key={loc.label}>{loc.label}</option>
                                    )
                                }
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="inputcont">
                            <Form.Label>Subcategory</Form.Label>
                            <Form.Select as="select" name="category" value={filterinput?.category} onChange={(event) => { onInputValidation(event) }}>
                                <option value="All">All Sub Category</option>
                                {
                                    subCategory.map(scat =>
                                        <option value={scat.label} key={scat.label}>{scat.label}</option>
                                    )
                                }
                            </Form.Select>
                        </Form.Group>
                        {!hidefilter?.includes("keyword") && <Form.Group className="inputcont">
                            <Form.Label>Keywords</Form.Label>
                            <Form.Control type="text" placeholder="Search all of these words" aria-label='Search all of these words' name="keyword" value={filterinput.keyword} onChange={(event) => onInputValidation(event)} />
                        </Form.Group>}
                        {!hidefilter?.includes("min" || "max") && <Form.Group className="inputcont">
                            <Form.Label>Price Range</Form.Label>

                            <Form.Group className="d-flex gap-2 align-items-center">
                                <Form.Control type="text" placeholder="$ min" aria-label='$ mine' name="min" value={filterinput.min} onChange={(event) => onInputValidation(event)} />
                                <div>-</div>
                                <Form.Control type="text" placeholder="$ max" aria-label='$ maxe' name="max" value={filterinput.max} onChange={(event) => onInputValidation(event)} />
                            </Form.Group>
                        </Form.Group>}
                        {!hidefilter?.includes("startdate" || "enddate") && <div className="inputcont">
                            <Form.Label>Date From</Form.Label>
                            <div className="d-flex gap-2 ">
                                <CustomDatePicker
                                    value={filterinput.startdate}
                                    label="Start Date"
                                    onchange={(date) => { onInputValidation({ value: date, name: "startdate" }, "date") }}
                                    id={"catfilter_startdate"}
                                />
                                <CustomDatePicker
                                    value={filterinput.enddate}
                                    label="End Date"
                                    onchange={(date) => { onInputValidation({ value: date, name: "enddate" }, "date") }}
                                    mindate = {moment(filterinput.startdate).add(1, 'days').toDate()}
                                    id={"catfilter_enddate"}
                                />
                            </div>
                        </div>}
                        <Form.Group className="inputcont">
                            <Form.Label>Option</Form.Label>
                            <div className="">
                                    {!hidefilter?.includes("auction") && <Form.Group className="multiple-checkbox">
                                        <Form.Check custom type="checkbox" id="auction" name="auction" label="Auction" checked={filterinput?.itemtype.includes("auction")} onChange={(event) => { checkoption(event) }} />
                                    </Form.Group>}
                                    {!hidefilter?.includes("directBuy") && <Form.Group className="multiple-checkbox">
                                        <Form.Check custom type="checkbox" id="directbuy" name="directBuy" label="Direct buy" checked={filterinput?.itemtype.includes("directBuy")} onChange={(event) => { checkoption(event) }} />
                                    </Form.Group>}
                                    {/* <Form.Group className="multiple-checkbox">
                                <Form.Check custom type="checkbox" id="onSite" name="onSite" label="On Site Only" checked={filterinput?.itemtype.includes("onSite")} onChange={(event) => { onInputValidation(event) }} />
                            </Form.Group> */}
                                    {!hidefilter?.includes("buynow") && <Form.Group className="multiple-checkbox">
                                        <Form.Check custom type="checkbox" id="buy-now" name="buynow" label="Buy Now" checked={filterinput?.itemtype.includes("buynow")} onChange={(event) => { checkoption(event) }} />
                                    </Form.Group>}
                                    {!hidefilter?.includes("isshippable") && <Form.Group className="multiple-checkbox">
                                        <Form.Check custom type="checkbox" id="isshippable" name="isshippable" label="Shippable" checked={filterinput?.itemtype.includes("isshippable")} onChange={(event) => { checkoption(event) }} />
                                    </Form.Group>}
                                    {!hidefilter?.includes("pickuponly") && <Form.Group className="multiple-checkbox">
                                        <Form.Check custom type="checkbox" id="pickuponly" name="pickuponly" label="Pick Up Only" checked={filterinput?.itemtype.includes("pickuponly")} onChange={(event) => { checkoption(event) }} />
                                    </Form.Group>}
                                    {!hidefilter?.includes("completed") && <Form.Group className="multiple-checkbox">
                                        <Form.Check disabled={filterinput?.categoryGroup == "" && filterinput?.locationid == ""} custom type="checkbox" id="completed" name="completed" label="Completed" checked={filterinput?.itemtype.includes("completed")} onChange={(event) => { checkoption(event) }} />
                                    </Form.Group>}
                            </div>
                        </Form.Group>
                        </div>
                        <div className="borderui"></div>
                        <div className="d-flex gap-2 w-100 pt-4">
                            <Button onClick={() => {
                                resetFilter()
                                setviewModal(false)
                            }} className="btn-grey w-50 clickable">Reset</Button>
                            <Button onClick={() => {
                                setviewModal()
                                applyfilter({}, "all")
                            }} className="btn-secondary w-50">Apply</Button>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }

    return (
        <div className="category-filter ">
            <Accordion defaultActiveKey={defaultkey} onSelect={(key) => {
                if (key != null) {
                    if(key === "1" ) {  
                        if(filterinput.locationid === "") {
                            setdisplayloc(locationlist.slice(0, 5))
                        } else {
                            let index = locationlist.findIndex(i => i?.id ==filterinput.locationid)
                            setdisplayloc(locationlist.slice(0, index > 5 ? index + 1 : 5))
                        }
                    } else  if(key === "0") {
                        if(filterinput.categoryGroup === "") {
                            setdisplaycat(category.slice(0, 5))
                        } else {
                            let index = category.findIndex(i => i.label ==filterinput.categoryGroup)
                            setdisplaycat(category.slice(0, index > 5 ? index + 1 : 5))
                        }
                        
                    }
                }
            }}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header as="div">Categories</Accordion.Header>
                    <Accordion.Body>
                        {displaycat.map((categoryItem, index) => (
                            <div className="category-item" >
                                <div className={`category-txt  ${filterinput?.categoryGroup == categoryItem?.label ? "activesubcat" : ""}`} role={"button"} onClick={() => { setcat(categoryItem, "categoryGroup") }}>{categoryItem?.label}</div>
                                {filterinput?.categoryGroup == categoryItem?.label && <div className="px-4">
                                    {categoryItem?.subCategory?.map((subcat, sindex) => (
                                        <div className={`category-txt ${filterinput?.category == subcat?.label ? "activesubcat" : ""}`} role={"button"} onClick={() => { setcat(subcat, "category") }}>{subcat?.label}</div>
                                    ))}
                                </div>}
                            </div>
                        ))}
                        {category.length > displaycat.length && displaycat.length > 1 && <button className="btn-white more-button text-secondary" onClick={() => {
                            setdisplaycat(category.slice(0, displaycat.length + 5))
                        }}>more + </button>}
                    </Accordion.Body>
                </Accordion.Item>
                {!hidefilter?.includes("locationid") && <Accordion.Item eventKey="1">
                    <Accordion.Header as="div">Locations</Accordion.Header>
                    <Accordion.Body>
                        <div>
                            <div className="d-flex gap-2">
                                <Form.Group controlId="zipcode" className="w-50">
                                    <Form.Control type="text" maxLength={5} placeholder="Enter Zip code" aria-label='Enter zipcode' name="zipcode" value={filterinput.zipcode} onChange={(event) => onInputValidation(event)} />
                                </Form.Group>
                                <Form.Group controlId="distance" className="w-50">
                                    <Form.Select role={"button"} as="select" placeholder="Select Distance" aria-label='Select Distance' name="miles" value={filterinput.miles} onChange={(event) => onInputValidation(event)}>
                                        <option selected hidden>Select Distance</option>
                                        <option value="5">5 Miles</option>
                                        <option value="10">10 Miles</option>
                                        <option value="25">25 Miles</option>
                                        <option value="50">50 Miles</option>
                                        <option value="100">100 Miles</option>
                                        <option value="250">250 Miles</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>
                            <Button className="btn-grey w-100 my-2" style={{ opacity: (filterinput.zipcode?.length == 5 ||filterinput.miles) ? 1 : 0.5 }} disabled={!(filterinput.zipcode?.length == 5 || filterinput.miles)} onClick={() => { applyfilter({}, "location") }}>Apply</Button>
                            {displayloc.map((loc, index) => (
                                <div className="category-item" >
                                    <div className={`category-txt ${filterinput?.locationid == loc?.id ? "activesubcat" : ""}`} role={"button"} onClick={() => { setcat({ label: loc?.id }, "locationid") }}>{loc?.title}</div>
                                </div>
                            ))}
                            {locationlist.length > displayloc.length &&displayloc.length >1 && <button className="btn-white more-button text-secondary" onClick={() => {
                                setdisplayloc(locationlist.slice(0, displayloc.length + 5))
                            }}>more + </button>}
                        </div>
                    </Accordion.Body>
                </Accordion.Item>}
                {!hidefilter?.includes("keyword") &&
                    <Accordion.Item eventKey="5">
                        <Accordion.Header as="div">Keywords</Accordion.Header>
                        <Accordion.Body>
                            <Form.Group className="inputcont">
                                <Form.Control type="text" maxLength={150} placeholder="Search all of these words" aria-label='Search all of these words' name="keyword" value={filterinput.keyword} onChange={(event) => onInputValidation(event)} />
                                {
                                    filterinput.keyword && filterinput.keyword.error ? <small className="text-danger">{filterinput.keyword.error}</small> : null
                                }
                            </Form.Group>
                            <Button className="btn-grey w-100 my-2" style={{ opacity: filterinput.keyword != "" ? 1 : 0.5 }} disabled={!(filterinput.keyword != "")} onClick={() => { applyfilter({}, "keyword") }}>Apply</Button>
                        </Accordion.Body>
                    </Accordion.Item>
                }
                {!hidefilter?.includes("min" || "max") && <Accordion.Item eventKey="2">
                    <Accordion.Header as="div">Price Range</Accordion.Header>
                    <Accordion.Body>
                        <div>
                            <div className="d-flex gap-2 align-items-center">
                                <Form.Group controlId="min" className="w-50">
                                    <Form.Control type="text" placeholder="$ min" aria-label='$ mine' name="min" value={filterinput.min} onChange={(event) => onInputValidation(event)} />
                                </Form.Group>
                                <div className="diffline">–</div>
                                <Form.Group controlId="max" className="w-50">
                                    <Form.Control type="text" placeholder="$ max" aria-label='$ maxe' name="max" value={filterinput.max} onChange={(event) => onInputValidation(event)} />
                                </Form.Group>
                            </div>
                            {errors?.["price"] && <small className="text-danger">{errors?.["price"]}</small>}
                            <Button className="btn-grey w-100 my-2" style={{ opacity: (filterinput.min != "" || filterinput.max != "") ? 1 : 0.5 }} disabled={!(filterinput.min != "" || filterinput.max != "")} onClick={() => { applyfilter({}, "price") }}>Apply</Button>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>}
                {!hidefilter?.includes("startdate" || "enddate") && <Accordion.Item eventKey="3">
                    <Accordion.Header as="div">Date From (is it active?)</Accordion.Header>
                    <Accordion.Body>
                        <div>
                            <div className="">

                                <CustomDatePicker
                                    value={filterinput.startdate}
                                    label="Start Date"
                                    onchange={(date) => { onInputValidation({ value: date, name: "startdate" }, "date") }}
                                    id={"catfilter_startdate"}
                                />
                                <CustomDatePicker
                                    value={filterinput.enddate}
                                    label="End Date"
                                    onchange={(date) => { onInputValidation({ value: date, name: "enddate" }, "date") }}
                                    mindate = {moment(filterinput.startdate).add(1, 'days').toDate()}
                                    id={"catfilter_enddate"}
                                />
                            </div>
                            {errors?.["date"] && <small className="text-danger">{errors?.["date"]}</small>}
                            <Button className="btn-grey w-100 my-2" style={{ opacity: (filterinput.startdate || filterinput.enddate) ? 1 : 0.5 }} disabled={!(filterinput.startdate || filterinput.enddate)} onClick={() => { applyfilter({}, "date") }}>Apply</Button>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>}
                <Accordion.Item eventKey="4">
                    <Accordion.Header as="div">Options</Accordion.Header>
                    <Accordion.Body>
                        <div>
                            {!hidefilter?.includes("auction") && <Form.Group className="multiple-checkbox">
                                <Form.Check custom type="checkbox" id="auction" name="auction" label="Auction" checked={filterinput?.itemtype.includes("auction")} onChange={(event) => { checkoption(event) }} />
                            </Form.Group>}
                            {!hidefilter?.includes("directBuy") && <Form.Group className="multiple-checkbox">
                                <Form.Check custom type="checkbox" id="directbuy" name="directBuy" label="Direct buy" checked={filterinput?.itemtype.includes("directBuy")} onChange={(event) => { checkoption(event) }} />
                            </Form.Group>}
                            {/* <Form.Group className="multiple-checkbox">
                                <Form.Check custom type="checkbox" id="onSite" name="onSite" label="On Site Only" checked={filterinput?.itemtype.includes("onSite")} onChange={(event) => { onInputValidation(event) }} />
                            </Form.Group> */}
                            {!hidefilter?.includes("buynow")  && <Form.Group className="multiple-checkbox">
                                <Form.Check custom type="checkbox" id="buy-now" name="buynow" label="Buy Now" checked={filterinput?.itemtype.includes("buynow")} onChange={(event) => { checkoption(event) }} />
                            </Form.Group>}
                            {!hidefilter?.includes("isshippable")  && <Form.Group className="multiple-checkbox">
                                <Form.Check custom type="checkbox" id="isshippable" name="isshippable" label="Shippable" checked={filterinput?.itemtype.includes("isshippable")} onChange={(event) => { checkoption(event) }} />
                            </Form.Group>}
                            {!hidefilter?.includes("pickuponly")  && <Form.Group className="multiple-checkbox">
                                <Form.Check custom type="checkbox" id="pickuponly" name="pickuponly" label="Pick Up Only" checked={filterinput?.itemtype.includes("pickuponly")} onChange={(event) => { checkoption(event) }} />
                            </Form.Group>}
                            {!hidefilter?.includes("completed")  &&<Form.Group className="multiple-checkbox">
                                <Form.Check disabled={filterinput?.categoryGroup == "" && filterinput?.locationid == ""} custom type="checkbox" id="completed" name="completed" label="Completed" checked={filterinput?.itemtype.includes("completed")} onChange={(event) => { checkoption(event) }} />
                            </Form.Group>}
                        </div>
                    </Accordion.Body>
                </Accordion.Item>

            </Accordion>
            <Button disabled={isAllFieldsEmpty} onClick={() => {
              resetFilter()
            }} className="reset-btn">Reset</Button>

        </div>
    )
}
export const SortingItem = ({ onApply, sortvalue }) => {
    const [sorted, setsorted] = useState(sortvalue || "title___asc")

    useEffect(() => {
        setsorted(sortvalue);
    }, [sortvalue]);

    return (
        <div className="sorbyHOC w-100 d-flex justify-content-end">
        <Form.Group controlId="sort-by" className="d-flex align-items-center" style={{gap:'5px'}}>
            <Form.Label className="mb-0 text-bold" >Sort by</Form.Label>
            <Form.Select
                className="cat-sort"
                as="select"
                name="sortBy"
                value={sorted}
                onChange={(event) => {
                    let data = event?.target.value
                    data = data.split("___")
                    data = [{ "field": data[0], "direction": data[1] }]
                    setsorted(event?.target.value)
                    onApply(data)
                }}>
                    <option value="itemclosetime___asc">Listing Ending First</option>
                    <option value="itemclosetime___desc">Listing Ending Last</option>
                    <option value="itemlistingtime___desc">Newest Listing First</option>
                    <option value="itemlistingtime___asc">Oldest Listing First</option>
                    <option value="title___asc">Item Title A-Z</option>
                    <option value="title___desc">Item Title Z-A</option>
                    <option value="bidprice___asc">Price Low to High</option>
                    <option value="bidprice___desc">Price High to Low</option>
                </Form.Select>
            </Form.Group>
        </div>
    )
}
export const CustomDatePicker = ({ label, value, onchange, mindate,id }) => {
    const [cdate, setcdate] = useState(value)

    useEffect(() => {
        onchange(cdate) 
    }, [cdate])

    useEffect(() => {
     setcdate(value)
    }, [value])

    const formatDate = (date) => {
        if (!date) return ''
        const d = new Date(date)
        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`
    }

    const openPicker = (e) => {
        e.preventDefault();
        const input = document.getElementById(id);
        if (!input) return;
        if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
          input.focus();
          input.click();
        } else {
          input.showPicker?.() || input.focus();
        }
    };

    return (
        <div className="datetime-section" onClick={openPicker}>
           { <label className={`date-input-label form-control`} >  {`${cdate ? moment(cdate).format("MM/DD/YYYY") : label +" (MM/DD/YYYY)"}`} </label> }
            <input type="date" id={id} className={`date-input-container form-control`}  style={{ opacity:0, width:"0px"}} value={cdate ? formatDate(cdate) : ''} min={mindate ? formatDate(mindate) : ''} onChange={(e) => setcdate(e.target.value)} placeholderText={`${label} (MM/DD/YYYY)`} />
            <div className="px-2">{calender}</div>  
        </div>
    )
}